/**
 * Returns the grade for a given class year and current year.
 * @param classYear - The student's graduation year (e.g., 2026)
 * @param currentYear - The current graduating class year
 * @returns The grade (6-12) or 'k' for kindergarten
 */
export const getGradeFromClassYear = (classYear: number, currentYear: number): number | 'k' => {
  const grade = 12 - (classYear - currentYear);
  return grade < 0 ? 'k' : grade;
};
